import { defineMessages } from 'react-intl';

export const MeterDetails = defineMessages({
  deviceType: {
    id: 'app.common.meterDetails.deviceType',
    defaultMessage: 'Typ zařízení',
  },
  directElectricityMeter: {
    id: 'app.common.meterDetails.directElectricityMeter',
    defaultMessage: 'Přímý elektroměr',
  },
  direct: {
    id: 'app.common.meterDetails.direct',
    defaultMessage: 'Přímý',
  },
  indirect: {
    id: 'app.common.meterDetails.indirect',
    defaultMessage: 'Nepřímý',
  },
  mtp: {
    id: 'app.common.meterDetails.MCT',
  },
  numberOfPhases: {
    id: 'app.common.meterDetails.numberOfPhases',
    defaultMessage: 'Počet fází',
  },
  mounting: {
    id: 'app.common.meterDetails.mounting',
    defaultMessage: 'Typ montáže',
  },
  width: {
    id: 'app.common.meterDetails.width',
    defaultMessage: 'Šířka',
  },
  tariffs: {
    id: 'app.common.meterDetails.tariffs',
    defaultMessage: 'Počet tarifů',
  },
  minimumCurrent: {
    id: 'app.common.meterDetails.minimumCurrent',
    defaultMessage: 'Minimální proud',
  },
  measurementCategory: {
    id: 'app.common.meterDetails.measurementCategory',
    defaultMessage: 'Kategorie měření',
  },
  referenceCurrent: {
    id: 'app.common.meterDetails.referenceCurrent',
    defaultMessage: 'Referenční proud',
  },
  maximumCurrent: {
    id: 'app.common.meterDetails.maximumCurrent',
    defaultMessage: 'Maximální proud',
  },
  reservedPower: {
    id: 'app.common.meterDetails.reservedPower',
    defaultMessage: 'Velikost jističe',
  },
  inputSpecification: {
    id: 'app.common.meterDetails.inputSpecification',
    defaultMessage: 'Specifikace vstupu',
  },
  orientation: {
    id: 'app.common.meterDetails.orientation',
    defaultMessage: 'Montážní poloha',
  },
  gSize: {
    id: 'app.common.meterDetails.gSize',
    defaultMessage: 'Jmenovitý průtok G',
  },
  diameterNominal: {
    id: 'app.common.meterDetails.diameterNominal',
    defaultMessage: 'Dimenze DN',
  },
  layLength: {
    id: 'app.common.meterDetails.layLength',
    defaultMessage: 'Stavební délka',
  },
  flange: {
    id: 'app.common.meterDetails.flange',
    defaultMessage: 'Příruba',
  },
  thermalMeasurementType: {
    id: 'app.common.meterDetails.thermalMeasurementType',
    defaultMessage: 'Typ měření tepla',
  },
  flowRate: {
    id: 'app.common.meterDetails.flowRateUnit',
    defaultMessage: 'Průtok {unit}',
  },
  diameterDimensionNominal: {
    id: 'app.common.meterDetails.diameterDimensionNominal',
    defaultMessage: 'Průměr / Dimenze DN',
  },
  yes: {
    id: 'app.common.yes',
    defaultMessage: 'Ano',
  },
  no: {
    id: 'app.common.no',
    defaultMessage: 'Ne',
  },
  resistance: {
    id: 'app.common.meterDetails.resistance',
    defaultMessage: 'Odpor teploměrů',
  },
  installationPosition: {
    id: 'app.common.meterDetails.installationPosition',
    defaultMessage: 'Pozice průtokoměru',
  },
  equipmentCategory: {
    id: 'app.common.meterDetails.equipmentCategory',
    defaultMessage: 'Kategorie zařízení',
  },
  serialNumber2: {
    id: 'app.common.meterDetails.serialNumber2',
    defaultMessage: 'Sériové číslo 2',
  },
  hotWater: {
    id: 'app.common.meterDetails.hotWater',
    defaultMessage: 'Teplá voda',
  },
  woltman: {
    id: 'app.common.meterDetails.woltman',
    defaultMessage: 'Woltman',
  },
});
